import { SavedList } from 'services/savedLists/types';
import { SavedListTable } from './saved-list-table/saved-list-table';
import { RowSelectionState } from '@tanstack/react-table';

export interface SavedListWrapperProps {
  isLoading: boolean;
  savedLists: SavedList[];
  isCspUser: boolean;
  closeDrawer: () => void;
  onActionDrawer?: (rowSelected: RowSelectionState) => void;
  confirmBtnText: string;
  savedListDetailFeatureFlag?: boolean;
  showAllList?: boolean;
}

export const SavedListTableWrapper = ({
  isLoading,
  savedLists,
  isCspUser,
  closeDrawer,
  onActionDrawer,
  confirmBtnText,
  savedListDetailFeatureFlag = false,
  showAllList
}: Readonly<SavedListWrapperProps>) => {
  return (
    <>
      <div className="w-100 d-none d-md-flex">
        <SavedListTable
          isLoading={isLoading}
          shoppingLists={savedLists}
          isCspUser={isCspUser}
          onClose={closeDrawer}
          onActionDrawer={onActionDrawer}
          confirmBtnText={confirmBtnText}
          disableHighlightOnHover
          savedListDetailFeatureFlag={savedListDetailFeatureFlag}
          showAllList={showAllList}
        />
      </div>
      <div className="w-100 d-flex d-md-none">
        <SavedListTable
          isLoading={isLoading}
          shoppingLists={savedLists}
          isCspUser={isCspUser}
          isMobile
          onClose={closeDrawer}
          onActionDrawer={onActionDrawer}
          confirmBtnText={confirmBtnText}
          disableHighlightOnHover
          savedListDetailFeatureFlag={savedListDetailFeatureFlag}
          showAllList={showAllList}
        />
      </div>
    </>
  );
};
